module.exports = __webpack_public_path__ + "img/edit.485eb9d4.svg";